/* global axios */
import ApiClient from './ApiClient';

class BitrixStagesAPI extends ApiClient {
  constructor() {
    super('bitrix_stages', { accountScoped: true });
  }

  sync() {
    return axios.post(`${this.url}/sync`);
  }
}

export default new BitrixStagesAPI();
